import { ApolloError, gql, useMutation } from '@apollo/client';
import { JobFamilyGroupUpdateModelInput, JobFamilyGroupModel } from '@utmost.co/enterprise-models';

const UPDATE_JOB_FAMILY_GROUP = gql`
  mutation UpdateJobFamilyGroup($patch: JobFamilyGroupUpdateModelInput!) {
    jobFamilyGroup: updateJobFamilyGroup(patch: $patch) {
      name
      referenceId
    }
  }
`;

export const usePatchJobFamilyGroup = (onCompleted: () => void, onError: (error: ApolloError) => void) => {
  const [mutate, { loading }] = useMutation<
    { updateJobFamilyGroup: JobFamilyGroupModel },
    { patch: Partial<JobFamilyGroupUpdateModelInput> }
  >(UPDATE_JOB_FAMILY_GROUP, {
    onCompleted,
    onError
  });

  const patch = (input: Partial<JobFamilyGroupUpdateModelInput>): Promise<any> => {
    if (loading) {
      return Promise.resolve();
    }

    return mutate({
      variables: { patch: input }
    });
  };

  return { patch, loading };
};
